<template>
    <div class="table-fee-summary">
        <b-table-simple v-if="isDataLoaded" borderless class="text-right" responsive>
            <b-tr class="font-weight-bold">
                <b-td class="label">
                    Streitwert
                </b-td>
                <b-td/>
                <b-td>{{ formatCurrencyCents(feeSummary.amountDispute) }}</b-td>
            </b-tr>
            <b-tr>
                <b-td class="label"/>
                <b-td>netto/neutral</b-td>
                <b-td>Summe</b-td>
            </b-tr>
            <b-tr class="font-weight-bold">
                <b-td class="label">
                    Gesamtforderung
                </b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.net.amount) }}</b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.gross.amount) }}</b-td>
            </b-tr>
            <b-tr class="font-weight-bold text-success">
                <b-td class="label">
                    Bereits&nbsp;gezahlt
                </b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.net.payments) }}</b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.gross.payments) }}</b-td>
            </b-tr>
            <b-tr class="font-weight-bold">
                <b-td class="label">
                    Teil-&nbsp;/&nbsp;Gutschrift
                </b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.net.adjustment) }}</b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.gross.adjustment) }}</b-td>
            </b-tr>
            <b-tr class="font-weight-bold text-danger table-last-row">
                <b-td class="label">
                    Offene&nbsp;Forderung
                </b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.net.open) }}</b-td>
                <b-td>{{ formatCurrencyCents(feeSummary.gross.open) }}</b-td>
            </b-tr>
        </b-table-simple>
    </div>
</template>

<script>
    import {formatCurrencyCents} from '@js/functions/format';

    export default {
        props: {
            feeSummary: {
                type: Object,
                required: true,
            },
        },
        computed: {
            isDataLoaded() {
                return this.feeSummary.net && this.feeSummary.gross;
            },
        },
        methods: {formatCurrencyCents},
    }
</script>
